import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SubscriptionsService } from '../subscriptions.service';
import { ISubscription } from '../subscriptions.interface';
import * as _ from 'lodash';
import { IFeature } from '../../../features-page/features/features.interface';
import { ICompany } from '../../../companies-page/companies/companies.interface';
import { CompaniesService } from '../../../companies-page/companies/companies.service';
import { FeaturesService } from '../../../features-page/features/features.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-subscriptions-modal',
  templateUrl: './subscriptions-modal.component.html',
  styleUrls: ['./subscriptions-modal.component.css']
})
export class SubscriptionsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  subscription!: ISubscription;
  form!: UntypedFormGroup;
  submitted = false;
  features: IFeature[] = [];
  isDev!: boolean;
  curr!: string;
  isManax!: boolean;
  company!: ICompany;
  companies!: ICompany[];

  constructor(
    public _SubscriptionsService: SubscriptionsService,
    private _CompaniesService: CompaniesService,
    public _FeaturesService: FeaturesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    this.isManax = this._AuthService.isManax();
    this.loading = true;
    if (!this.subscription) {
      this.subscription = {
        company: this._AuthService.company(),
        features: []
      };
    }
    this.getCompanies();
    this.getFeatures();
  }

  getCompanies() {
    this._CompaniesService.getCompanies({ skip: 0, limit: 1000 }).subscribe((companies: any) => {
      this.companies = companies;
    })
  }

  getFeatures() {
    this._FeaturesService.getFeatures({
      // company: _.get(this.subscription, 'company._id'),
      limit: 1000, skip: 0,
      sort: 'name'
    }).subscribe((features) => {
      this.features = features;
      if (this.subscription._id) this.getSubscription();
      else {
        this.buildForm();
        this.loading = false;
      }
    });
  }

  getSubscription() {
    this.loading = true;
    this._SubscriptionsService.getSubscription(this.subscription._id || '').subscribe((subscription) => {
      this.subscription = subscription;
      // this.company = this.subscription.company;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    let features = (this.subscription.features || []).map(el => el._id);
    this.form = this.fb.group({
      company: _.get(this.subscription, 'company._id'),
      features: [features],
      isDeleted: [_.get(this.subscription, 'isDeleted')]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ISubscription = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    // data.company = this._AuthService.companyId();
    if (this.subscription._id) {
      data._id = this.subscription._id;
      this._SubscriptionsService.updateSubscription(data).subscribe((product) => {
        this.dialog.close(product);
      });
    } else {
      this._SubscriptionsService.createSubscription(data).subscribe((product) => {
        this.dialog.close(product);
      });
    }
  }
}